import React from "react";
import ReactWordCloud from "react-d3-cloud";

export default function WordCloudChart({ data }) {
  return (
    <div className="chartCard wordCloud">
      <h3>Saved Properties Word Cloud</h3>
      <ReactWordCloud
        data={data}
        fontSize={(word) => Math.log(word.value) * 24}         
        rotate={function () { return (~~(Math.random() * 2) * 90); }} 
        spiral="rectangular"
        width={500}
        height={350}
      />
    </div>
  );
}
